// extracted by mini-css-extract-plugin
export default {"root":"GeneralDetails_root__5p64v","tnc-label":"GeneralDetails_tnc-label__8IuQo","checkbox-wrapper":"GeneralDetails_checkbox-wrapper__w+BHv"};